// Charge items plus the editable numbers inside a dynamic Min Freight formula, as one flat list
// of { key, group, name, unit, value, editable } - the same shape the backend validates against.
export const flattenCharges = (charges = []) => {
  const out = [];
  charges.forEach((c) => {
    out.push(c);
    (c.formula || []).forEach((part) => {
      if (part.key) {
        out.push({
          key: part.key,
          group: c.group,
          name: `${c.name} · formula value`,
          unit: part.unit || "",
          value: part.value,
          editable: true,
        });
      }
    });
  });
  return out;
};

// State charge values as flat items (same keys the backend validates): sc:<id>:amount |
// sc:<id>:perKgAmount | sc:<id>:slab:<slabId>:amount|minValue
export const stateChargeItems = (stateCharges = []) => {
  const out = [];
  stateCharges.forEach((sc) => {
    const label = `${sc.chargeName} · ${sc.stateName}`;
    if (sc.rateMode === "slab") {
      sc.slabs.forEach((slab) => {
        const range = `${slab.from}–${slab.to} ${slab.unit}`;
        out.push({ key: `sc:${sc.id}:slab:${slab.id}:amount`, group: "State charges", name: `${label} · ${range} · per ${slab.unit}`, unit: `₹/${slab.unit}`, value: slab.amount, editable: true });
        out.push({ key: `sc:${sc.id}:slab:${slab.id}:minValue`, group: "State charges", name: `${label} · ${range} · minimum`, unit: "₹", value: slab.minValue, editable: true });
      });
    } else {
      out.push({ key: `sc:${sc.id}:amount`, group: "State charges", name: `${label} · minimum`, unit: "₹", value: sc.amount, editable: true });
      out.push({ key: `sc:${sc.id}:perKgAmount`, group: "State charges", name: `${label} · per kg`, unit: "₹/kg", value: sc.perKgAmount, editable: true });
    }
  });
  return out;
};
